import type { UseMutationResult } from "@tanstack/react-query";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { getBrandById } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

export function useDismissBrandReview(): UseMutationResult<
  unknown,
  unknown,
  number,
  unknown
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (brandId: number) =>
      apiClient.url(`/brands/${brandId}/dismiss-review`).post().res(),

    onSuccess: (_data, brandId) => {
      queryClient.invalidateQueries({
        queryKey: getBrandById.getBrandById(brandId),
      });
    },
  });
}
